import {RouteView, PageView} from '../layouts'

export const bigConsumer = {
        path: '/bigConsumer',
        name: 'BaseForm',
        component: PageView,
        meta: {title: '大客户管理', icon: 'dollar', isMenuShow: true, permission: 'bigClient'},
        children: [
            {
                path: '/bigConsumer/carManageIndex',
                name: 'carManage',
                component: PageView,
                // redirect:'/bigConsumer/carManageIndex',
                // component: () => import('../views/bigConsumer/carManageIndex.vue'),
                meta: {title: '车辆管理', keepAlive: false, isMenuShow: true, permission: 'bigClient:vehicle'},
                children: [
                    {
                    path: '/bigConsumer/carManageIndex',
                    name: 'carManage',
                    // component: PageView,
                    component: () => import('../views/bigConsumer/carManageIndex.vue'),
                    meta: {title: '车辆管理', keepAlive: false, isMenuShow: true, permission: 'bigClient:vehicle'},
                    children: []
                    },
                    {
                    path: '/bigConsumer/bindLoseTable',
                    name: 'bindLoseTable',
                    // component: PageView,
                    component: () => import('../views/bigConsumer/bindLoseTable.vue'),
                    meta: {title: '绑车失败记录', keepAlive: false, isMenuShow: true, permission: 'bigClient:vehicle'},
                    children: []
                    },
                ]
            },
            {
                path: '/bigConsumer/shareManage',
                name: 'shareManage',
                // component: PageView,
                // redirect:'/bigConsumer/shareManageIndex',
                component: () => import('../views/bigConsumer/shareManageIndex.vue'),
                meta: {title: '分享管理', keepAlive: false, isMenuShow: true, permission: 'bigClient:share'},
                children: []
            }
        ]
}


